'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dSites$002dPage$0024 from "./presto.-List-Sites-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002487 from "./presto.-Presto-Router$$anon$87.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$86() {
  this.bpr = null;
  this.bpj = null;
  this.bpk = false;
  this.bps = null;
  this.bpt = false;
  this.bpw = null;
  this.bpp = null;
  this.bpq = false;
  this.bpl = null;
  this.bpm = false;
  this.bpn = null;
  this.bpo = false;
  this.bpu = false;
  this.bpv = false;
  this.bpr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bpw = "ListSitesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$86 as $c_Lpresto_PrestoRouter$$anon$86 };
$p = $c_Lpresto_PrestoRouter$$anon$86.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$86;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$86() {
}
export { $h_Lpresto_PrestoRouter$$anon$86 as $h_Lpresto_PrestoRouter$$anon$86 };
$h_Lpresto_PrestoRouter$$anon$86.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bpr;
});
$p.M = (function() {
  if ((!this.bpk)) {
    this.bpj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bpk = true;
  }
  return this.bpj;
});
$p.O = (function() {
  if ((!this.bpt)) {
    this.bps = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bpt = true;
  }
  return this.bps;
});
$p.D = (function() {
  return this.bpw;
});
$p.t = (function() {
  if ((!this.bpq)) {
    this.bpp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bpq = true;
  }
  return this.bpp;
});
$p.N = (function() {
  if ((!this.bpm)) {
    this.bpl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bpm = true;
  }
  return this.bpl;
});
$p.Q = (function() {
  if ((!this.bpo)) {
    this.bpn = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002487.$c_Lpresto_PrestoRouter$$anon$87();
    this.bpo = true;
  }
  return this.bpn;
});
$p.v = (function() {
  if ((!this.bpv)) {
    this.bpu = false;
    this.bpv = true;
  }
  return this.bpu;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee556) => ((p) => \u03b4scrutinee556))($j_presto$002e$002dList$002dSites$002dPage$0024.$m_Lpresto_ListSitesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$86 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$86, "presto.PrestoRouter$$anon$86", ({
  P3: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$86 as $d_Lpresto_PrestoRouter$$anon$86 };
//# sourceMappingURL=presto.-Presto-Router$$anon$86.js.map
